// extracted by mini-css-extract-plugin
export default {"container":"Top_container__B4q7H","icon":"Top_icon__cZuio"};